import React from 'react'
import { Button } from 'components';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Final = () => {

	const { patientId } = useParams();
    const {t} = useTranslation();

    return (
        <div>
            <div className="rounded-md border mt-24 border-grey-light py-10 px-20 bg-white flex flex-wrap justify-center max-w-2xl	">
                <p className="relative block w-full mb-6 text-2xl text-orange text-center">{t('patientLoadedSuccessfully')}</p>
                <Button type="link" to={`/patient/${patientId}`} background className="w-52">{t('seePatient')}</Button>
            </div>
        </div>
    )
}
